<template>
  <div class="the-sidebar">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TheSidebar'
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.the-sidebar{
  position: relative;
  width: $sidebarWidth;
  height: 100%;
  background: $sidebarBgColor;
  box-shadow: $sidebarShadow;
}
</style>
